export const REGISTER_STEP = 1;
export const PROFILE_STEP = 2;
export const COMPETITOR_STEP = 3;
